import { useState } from "react";
import { useQuery } from "@apollo/client";
import { Card, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";

import StaffTable from "./components/StaffTable";
import { GET_STAFF_LIST } from "../../graphql/queries/management";
import AddIcon from "../../components/common/AddIcon";
import SimpleModal from "../../components/common/SimpleModal";
import StaffForm from "./components/form/StaffForm";

const Staff = () => {
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleAdd = () => setShowModal(true);

  const { data } = useQuery(GET_STAFF_LIST, {
    onError() {
      toast.error(`ບໍສາມາດໂຫຼດຂໍ້ມູນໄດ້, ກາລຸນາລອງໃໝ່`, {
        position: "top-center",
        className: "lao",
      });
    },
  });

  return (
    <>
      <SimpleModal
        show={showModal}
        handleClose={handleCloseModal}
        title="ແກ້ໄຂຂໍ້ມູນພະນັກງານ"
      >
        <StaffForm handleClose={handleCloseModal} />
      </SimpleModal>

      <Row className="lao">
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>
                <h3 className="p-1">ຈັດການຂໍ້ມູນພະນັກງານ</h3>
              </Card.Title>
              <AddIcon onClick={handleAdd} />
            </Card.Header>
            <Card.Body>
              <StaffTable data={data?.staffList} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Staff;
